// PATH: src/hooks/useCanEditStudents.ts — droit d'écriture sur le dossier élève.
//
// Miroir du gate backend `ecritureEleve` (rts_school/school.go) : compte
// BUSINESS, ou fonction locale DIRECTION ou SURVEILLANT_GENERAL. Un enseignant
// consulte les élèves sans les inscrire, modifier, archiver ni gérer leurs
// tuteurs. Masquer les actions ne protège rien — le backend refuse de toute
// façon — mais évite de proposer des boutons qui ne mèneraient qu'à un 403.
//
// La fonction locale n'est pas dans le JWT : seul user_type_code y figure.
// Elle se résout en base, d'où l'appel à /me/staff pour tout compte non BUSINESS.
import { useEffect, useState } from "react";
import { useApiClient } from "../api/apiClients";
import { useAuth } from "../context/AuthContext";

const WRITER_FUNCTIONS = new Set(["DIRECTION", "SURVEILLANT_GENERAL"]);

export interface CanEditStudents {
  canEdit: boolean;
  /** true tant que la fonction locale n'est pas résolue — afficher un 403 trop tôt serait faux. */
  loading: boolean;
}

export const useCanEditStudents = (): CanEditStudents => {
  const http = useApiClient("tilmischool");
  const isBusiness = useAuth().user?.userTypeCode === "BUSINESS";
  const [state, setState] = useState<CanEditStudents>({ canEdit: isBusiness, loading: !isBusiness });

  useEffect(() => {
    if (isBusiness) {
      setState({ canEdit: true, loading: false });
      return;
    }
    let cancelled = false;
    http
      .get<{ role?: string; linked: boolean }>("/api/v1/school/me/staff")
      .then((r) => {
        if (!cancelled) setState({ canEdit: r.data.linked && WRITER_FUNCTIONS.has(r.data.role ?? ""), loading: false });
      })
      // Échec de résolution : on ferme. Un bouton manquant se signale ; une
      // écriture refusée après saisie d'un formulaire entier, non.
      .catch(() => { if (!cancelled) setState({ canEdit: false, loading: false }); });
    return () => { cancelled = true; };
  }, [http, isBusiness]);

  return state;
};
